// extracted by mini-css-extract-plugin
module.exports = {"LogoAndTitle__imageWrapper":"LogoAndTitle_LogoAndTitle__imageWrapper__1uLrT","LogoAndTitle__cancel":"LogoAndTitle_LogoAndTitle__cancel__2K7RC"};